import { render, staticRenderFns } from "./GridBox4.vue?vue&type=template&id=c4f3d2e0&scoped=true"
var script = {}
import style0 from "./GridBox4.vue?vue&type=style&index=0&id=c4f3d2e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f3d2e0",
  null
  
)

export default component.exports